<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-7"></a><span href="#/toc#toc-chapter002" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> O<span class="small-caps">NE</span></span></h1>
<p class="img1"><img alt="image" src="images/Art_orn.jpg"/></p>
<p class="noindent"><span class="dropcap">H</span>oo, boy.” Zane McCord grinned when he walked into the big kitchen of the Lost Nugget ranch house and caught sight of his cousins,
         Jesse and Wyatt. “You two look a whole lot better’n those cows I’ve been tending.”
      </p>
<p>Jesse grinned. “Two weeks up in the hills, and you look more like a grizzly than a human.”</p>
<p>Zane ran a hand over his rough beard. “The cattle don’t care what we look like as long as we deliver food in the snow.”</p>
<p>Though spring had arrived in Montana, the mountains were still hip-deep in drifts. A storm had dropped nearly a foot of snow
         the previous weekend.
      </p>
<p>Cal Randall, foreman of the Lost Nugget, turned from the stove where he was filling a mug with coffee. “These late snowfalls
         play hell with the calving.”
      </p>
<p>“Yeah. But the flip side is”—Zane pulled a tiny video camera from his shirt pocket—“I got some fabulous shots <a id="page-8"></a>of the hills buried in fresh snow. They’ll make a great background for the introduction I’m planning for my documentary. I
         can see the camera panning a vast, snow-covered wilderness, while a voice intones, ‘When Coot McCord died, the town of Gold
         Fever called him crazy for having spent a lifetime searching for the lost treasure of his ancestors. How could anyone in his
         right mind believe one man could find a sack of gold nuggets in such a primitive setting? But Coot’s grandsons pledged at
         his graveside to carry on his search. This, then, is the record of one family’s dream, and the successful conclusion of a
         treasure hunt that began in 1862, at Grasshopper Creek, in the Montana wilderness.’ ”
      </p>
<p>“Sounds great, cuz.” Wyatt punched his arm. “Especially that part about the successful conclusion. The sooner the better.”</p>
<p>“Yeah. Hey, it’s slow going, but we’re all committed.”</p>
<p>Jesse nodded. “I’ve found another piece of equipment I’d like to have shipped out here as soon as the snow melts up in the
         hills.”
      </p>
<p>“Good. I wish we could find a piece of radar that could see through tons of rock.”</p>
<p>The three shared a grin as Jesse added, “If such a thing is ever invented, we’ll be the first to buy it.”</p>
<p>“Hey, Zane.” Jesse’s wife, Amy, stepped into the kitchen. “Welcome back to civilization.”</p>
<p>Jesse and Amy embraced and even when they moved apart, Amy kept her arm around his waist.</p>
<p>“You staying for supper?” she asked Zane.</p>
<p>“Depends. What’s Dandy fixing?”</p>
<p>“Slow-cooked pot roast.”</p>
<p>Their ranch cook had been with the family for more than <a id="page-9"></a>thirty years, and he knew just how to please a hardworking cowboy. From fiery chili to perfectly grilled steaks, nobody in
         Montana made better meals than Dandy Davis.
      </p>
<p>“I’m definitely not giving up Dandy’s pot roast for Daffy Spence’s greasy burgers.”</p>
<p>At his reference to Daffy, owner of the Fortune Saloon in the nearest town of Gold Fever, the others began laughing just as
         Wyatt’s bride, Marilee, stepped through the doorway and paused to brush a kiss over her husband’s cheek. “Hello, you.”
      </p>
<p>“Hello, yourself.” Wyatt affectionately brushed a lock of red hair from her eye.</p>
<p>Zane turned to Cal with a mock shudder. “There’s just way too much of this newlywed affection going on here. I hope it isn’t
         contagious.”
      </p>
<p>“I wouldn’t worry, if I were you.” Cal shared a laugh with the others. “We’ve seen the way you keep cutting fresh fillies
         out of the herd and then discarding them.”
      </p>
<p>Zane smiled. “So many women. So little time.”</p>
<p>“So I’ve noticed.” Cal grinned. “I think your bachelor days won’t be threatened until you’re old and gray.”</p>
<p>“Like you, Cal?”</p>
<p>The old cowboy chuckled before ducking his head in embarrassment.</p>
<p>It occurred to Zane that the only woman who ever really got Cal’s attention was their aunt, Cora McCord. An artist who was
         a bit of an eccentric, she was more comfortable wearing her brother’s cast-off clothing while she worked in her studio. And
         though her paintings brought fabulous sums of money from art patrons around the world, she remained a simple woman who had
         turned her back on the European art scene to live in her beloved Montana.
      </p>
<p><a id="page-10"></a>“Where’s Aunt Cora?”
      </p>
<p>“Off on one of her nature campouts. While a spring blizzard rages.”</p>
<p>Zane heard the worry in Cal’s voice and was quick to soothe. “She’ll be fine, Cal. And if she doesn’t check in tonight, we’ll
         send the cavalry after her.”
      </p>
<p>“I’ll be leading the charge,” the foreman said firmly.</p>
<p>Zane gave him a long look. “Is that a clean shirt in the middle of the day?”</p>
<p>Cal nodded. “Thought I’d clean up for the interview.”</p>
<p>“Interview?” Zane glanced around. “What’ve I missed?”</p>
<p>Cal took a sip of coffee before saying, “With Coot gone, I’m buried in paperwork. I complained to our accounting firm in Helena,
         and they agreed to send me their new hotshot bookkeeper to clean up the mess.”
      </p>
<p>“A hotshot bookkeeper is coming all this way?”</p>
<p>“Schooled in the East.” Cal took a sip of coffee. “Guy named Riley Mason.”</p>
<p>“A city boy?” The cousins shared a grin. “How long do you think he’ll last out here?”</p>
<p>Cal shrugged. “Depends. The last one they sent lasted all of four days before he said he needed to get back to civilization.
         Can’t say I blame him. If he’s used to spending his off-hours at coffeehouses or bars, there’s just not that much to entice
         him into feeling at home here. And after a visit to town, and a night at the Fortune Saloon, what’s left? So I told them to
         send someone who’s not only sharp, but willing to spend a lot of his downtime doing ordinary things like reading or watching
         old videos.”
      </p>
<p>Zane nodded in agreement. “How long would you like him to stay?”</p>
<p><a id="page-11"></a>Cal thought about it. “I guess that depends on what he finds. I figure he’s going to need a couple of weeks, maybe months,
         to get everything into a computer database so the Helena firm can handle all those mysterious government forms that need to
         be filled out in triplicate.”
      </p>
<p>“Where will he stay?”</p>
<p>Cal pointed his mug toward the doorway. “He can have his pick of empty rooms. There’s that bedroom next to the office that
         would probably work best.”
      </p>
<p>“If he doesn’t mind living in a cave.” Marilee gave a throaty chuckle. “Maybe you can keep him chained to his desk, Cal. Then
         he can clear up the paperwork in half the time.”
      </p>
<p>“Believe me, I’d be happy to, as long as I wouldn’t have to deal with legal documents ever again. I don’t know how Coot could
         stand doing all the paperwork involved in running this place.”
      </p>
<p>“Good luck with the interview. I’m more interested in supper.” Zane turned away, rubbing a hand over his bristly beard. “Excuse
         me while I head upstairs for the longest shower and shave in history.”
      </p>
<p>He ambled out of the kitchen and was heading through the great room on his way to the stairs when he heard a knock on the
         front door.
      </p>
<p>Since nobody but a stranger would ever use the front entrance, Zane was grinning good-naturedly as he grasped the knob and
         threw open the door to admit the accountant.
      </p>
<p>“Hello.”</p>
<p>Zane knew he was staring, but it took him a moment to switch gears. He’d expected a dark suit and he wasn’t disappointed.
         And a firm handshake, which he returned woodenly. But the image of the nerdy accountant in <a id="page-12"></a>his mind was replaced by a gorgeous female, dark hair slicked back into a knot at the back of her head, trim figure encased
         in a knee-skimming dark skirt and figure-hugging jacket. And that was quite a figure to hug.
      </p>
<p>Then there was the voice. Soft and breathy, with just a hint of nerves.</p>
<p>“I’m Riley Mason. Are you Cal Randall?”</p>
<p>“No. Cal’s in his office.” Because she was female, and because it came naturally to him, Zane gave her one of his most charming
         smiles. “My name’s Zane. I’ll show you the way.”
      </p>
<p>“That’s all right.” She took a step back, studying him warily. “Maybe I’ll just wait here and you can tell him I’ve arrived
         for my interview.”
      </p>
<p>He realized, too late, that he probably smelled like a barnyard and looked like a trail bum, causing her to be completely
         repelled.
      </p>
<p>“At least wait inside.” He held the door wider, and she was forced to accept his invitation to step inside.</p>
<p>She did so hesitantly.</p>
<p>As she brushed past him, he breathed her in. Her hair smelled like a spring garden. Something light and floral and fresh as
         a breeze.
      </p>
<p>For two long weeks he’d smelled nothing but horses and saddle leather and unwashed wranglers.</p>
<p><em>Pure heaven</em>, he thought as he gave her one last look. “I’ll go get Cal.”
      </p>
<p>He sauntered away, leaving her standing in the foyer, staring after him.</p>
<p class="space-break">Riley didn’t relax until the cowboy disappeared along a hallway. She’d known, of course, that the Lost Nugget <a id="page-13"></a>was a working ranch. But she’d assumed that she would be isolated from the wranglers, since she’d been told they lived in
         bunkhouses scattered across thousands of acres of rangeland.
      </p>
<p>Not that she felt herself above working cowboys. She’d been working since she was fifteen, and she was proud of it. But if
         the men on the ranch looked anything like that one, she preferred to give them a wide berth. There had been a fierce, dangerous
         look to him. Like a throwback to the cowboys of the Old West who could calmly shoot a gunslinger, toss back a glass of whiskey,
         and ride out of town without a backward glance.
      </p>
<p>Silly, she knew. She’d always been cursed with a wild imagination. But being on a ranch in Montana was about as far from her
         comfort zone as possible.
      </p>
<p>“You’re not in Philly anymore, little girl,” she muttered.</p>
<p>She watched the approach of a handsome, white-haired man. Now this was how she’d envisioned Cal Randall, foreman of the Lost
         Nugget. Tall, rangy, weathered, and extremely courtly as he extended his hand.
      </p>
<p>“Riley Mason? Cal Randall.”</p>
<p>“So nice to meet you, Mr. Randall.”</p>
<p>“That’s too formal for my taste. Call me Cal.” He put a hand beneath her elbow. “Let’s go to my office and chat.”</p>
<p>They passed through an enormous room with a four-sided fireplace surrounded by comfortable furniture. The floor-to-ceiling
         windows offered an incredible view of the towering spires of the mountains in the distance. Riley caught her breath at the
         sheer beauty of it.
      </p>
<p>Before she could take it all in, Cal led her along a hallway and paused to open a set of double doors. Inside <a id="page-14"></a>was a purely masculine retreat, complete with walls of shelves holding an assortment of leather-bound books and yet another
         fireplace.
      </p>
<p>Cal settled himself into a leather chair behind an oversize desk littered with paperwork. He indicated a chair across from
         him and Riley perched on the edge of the seat.
      </p>
<p>Seeing her nerves, he strove to put her at ease. “Tell me about yourself, Riley.”</p>
<p>“I’m twenty-four. Fresh out of college.” She flushed. “I took some time off to work, so that set me back a bit. I’ve worked
         since I was fifteen. Mostly as a clerk in a local store, and at a coffeehouse off-campus. I’m trained in accounting. But I
         have to be honest with you.” She stared openly at the mountains of paperwork that spilled from open file drawers and was piled
         haphazardly on top of every available surface. “I just don’t know how much help I can be until I have a chance to look over
         some of this. It looks—”
      </p>
<p>Cal interrupted. “I know what you mean.” He tapped a pen against the desktop. “It intimidates the hell out of me.”</p>
<p>That had the desired effect, causing her to relax a bit as she matched his grin.</p>
<p>“I’m current with state and federal guidelines on fees and assessments, and even though I haven’t been in Montana long, I
         know I can get up to speed on local issues as well.”
      </p>
<p>She dug an envelope out of her pocket and set it on the desk. “Our firm suggested independent assessments of my work. These
         are the e-mail addresses of my immediate superiors at our Philadelphia firm, and also my college professors who are familiar
         with me. They agreed to answer any questions you might have about my abilities. They were in contact with the firm in Helena
         before I was hired.”
      </p>
<p><a id="page-15"></a>She took in a breath. “I’ve been apprised of your business and I’m of course prepared to handle daily sheets and payroll.
         I think I could get all the necessary paperwork ready for our CPA firm in Helena. And though I can’t promise miracles, I’m
         pretty sure I could get most of this”—she indicated the desk—“cleaned up and in some sort of order. But, as I said, neither
         of us will really know what I’m capable of until I take a look at the work you need done.”
      </p>
<p>Cal grinned. “That was quite a mouthful.”</p>
<p>Riley flushed, knowing he had seen through her prepared remarks. She’d rehearsed them all the way out here.</p>
<p>“I don’t value speed nearly as much as I value efficiency. I told the firm that I want someone who will take the time to simplify
         this paperwork and make my job run smoothly.” Cal leaned back in his chair. “And, to make your job a bit easier, I’m prepared
         to offer you a room here.”
      </p>
<p>She seemed surprised. “The firm didn’t say anything about living on the ranch.”</p>
<p>“Is that a problem?”</p>
<p>She hesitated. “Before driving out here, I arranged for a room in Gold Fever, with a lady named Delia Cowling, who was recommended
         by a banker in Helena.”
      </p>
<p>Cal smiled. “I know Delia. Her brother was owner of the Gold Fever bank before his untimely death.” He thought a minute. “As
         you know, the ranch is an hour’s drive from town. Living here could save you time, as well as gas and wear and tear on your
         car.”
      </p>
<p>The way she was chewing on her lower lip told Cal that something was bothering her. “Of course, the decision is up to you,
         Riley. I certainly don’t want you to find yourself in an uncomfortable situation.”
      </p>
<p><a id="page-16"></a>She took a deep breath. “I didn’t come to town alone. I have a four-year-old daughter.”
      </p>
<p>“Oh.” It was Cal’s turn to be surprised. “Is your husband okay with the hours you’ll be away?”</p>
<p>Her head came up. “My husband?”</p>
<p>“I figure he’ll be stuck with some of the child care if you sign on for this.”</p>
<p>Riley realized she’d been sitting on the edge of her seat. She sat back in the chair and met Cal’s questioning look directly.
         “I didn’t mean to mislead you. I don’t have a husband. I’ve never been married. There’s just Summer and me.”
      </p>
<p>“I see.” He saw more. Much more. Though the job interview may have unnerved her, questions about her private life were infinitely
         more painful. This was obviously not the first time she’d been asked about her unmarried status. Though she was direct and
         honest, she didn’t volunteer any more information than necessary. Despite her honest explanation, he could see the way her
         chin came up, waiting for him to throw the first punch.
      </p>
<p>“You haven’t said if you’d be willing to live here on the ranch.”</p>
<p>“I… I’d be more than willing, as long as you understand that I’d be bringing along my daughter.”</p>
<p>“That’s fine with me.” Cal stared at the envelope she’d dropped on his desk. “I don’t need to check any further references,
         Riley. Our firm in Helena had nothing but good things to say about your work. That’s good enough for me. So, if you’re agreeable,
         I’d like you to get started as quickly as possible.”
      </p>
<p>His abrupt end to the interview caught her by surprise. She’d expected Cal Randall, once he’d heard about her <a id="page-17"></a>daughter, to use her references, or possibly her lack of experience, as an excuse to dismiss her. She’d expected him to be
         like so many others who judged her without even knowing her.
      </p>
<p>And he had, she realized. But he was judging her by her work ethic, and not by her personal life.</p>
<p>Cal got to his feet and leaned across the desk to extend his hand. “If you’d like to wait in the great room, I’ll phone the
         firm in Helena and affirm your employment.”
      </p>
<p>She was reeling from the speed with which he’d come to a decision.</p>
<p>She stood and offered her hand. “Thanks for giving me this opportunity, Cal.” She turned toward the door.</p>
<p>“Can you find your way?” he called to her retreating back.</p>
<p>“Yes. I’m fine with it.” Riley closed the door and backtracked until, pausing in the massive great room, she sank into an
         overstuffed chair, feeling a wave of giddy relief.
      </p>
<p>Needing to calm her nerves, she closed her eyes and took long, deep breaths until her heartbeat returned to normal.</p>
<p class="space-break">Zane was whistling as he descended the stairs and headed toward the kitchen. He’d noted the door to Cal’s office was closed,
         and he wondered about the foreman’s reaction to the new guy, Riley. That had Zane grinning. It was a natural mistake, and
         they’d all been guilty. Who’d have believed the new hire would be female? And so darned pretty.
      </p>
<p>In the great room he came to an abrupt halt. The object of his thoughts was seated in a chair, hands folded in her <a id="page-18"></a>lap, head back, eyes closed, practicing some sort of deep breathing.
      </p>
<p><em>Yoga?</em> he wondered.
      </p>
<p>He took that moment to study her more closely, enjoying the way a lock of dark hair had fallen from that prim knot to curl
         against her cheek. Such a pretty, dimpled cheek. Everything about her was pretty. And soft. From the lips, pursed as though
         in prayer, to the gentle curve of her eyebrows.
      </p>
<p>Just then her eyes opened and she caught him staring.</p>
<p>“Hi again.”</p>
<p>At the sound of his voice her eyes widened in recognition. “You’re… the one I met at the front door.”</p>
<p>“Zane.”</p>
<p>“Yes, of course. Zane.”</p>
<p>“When do you get to tackle Cal’s office mess?”</p>
<p>“Whenever he wants me to start.”</p>
<p>“I’d say the sooner the better. Cal doesn’t have much patience with paperwork.”</p>
<p>“That’s what he told me.” She laughed. “Fortunately, it’s what I do best.”</p>
<p>Just then Cal stepped into the room. “You two getting acquainted?”</p>
<p>“Yeah. When does Riley start?”</p>
<p>Cal turned to her. “You’ll need tomorrow to move your things out here and get settled in. Then you can start the following
         morning. How does that sound?”
      </p>
<p>“Perfect.” She offered her hand. “I’d better get back to town now. I have to get the rental car back before closing.”</p>
<p>Cal accepted her handshake. “Rental car? How did you get here from Helena?”</p>
<p><a id="page-19"></a>“Bus.”
      </p>
<p>“Well, then, you’ll need some help getting your stuff out here.”</p>
<p>“Oh, I don’t think…”</p>
<p>Zane interrupted. “I’m free in the morning. I could take one of the ranch trucks into town and lend a hand.”</p>
<p>“No. That isn’t neces—”</p>
<p>“Perfect.” Ignoring her protest, Cal gave Riley a smile. “How does eight o’clock sound?”</p>
<p>“Yes. All right.” She turned to Zane. “Thanks for the offer. I’m staying at Delia Cowling’s place. Do you know it?”</p>
<p>“Sure thing.” Zane’s smile grew. “I’ll see you at eight.”</p>
<p>When she and Cal walked to the front door, Zane stood admiring her backside.</p>
<p>Minutes later, when Cal closed the door and joined him, he was grinning like a conspirator.</p>
<p>“Very slick,” Cal muttered as they made their way to the kitchen.</p>
<p>“I was thinking the same thing. Thanks for giving me that perfect opening. It’ll give me a chance to get to know our pretty
         new accountant.”
      </p>
<p>“A word of warning.” Cal paused at the kitchen door. “She’s going to be an employee now, Zane. You make the wrong moves, she
         could sue you for harassment.”
      </p>
<p>“Me?” Zane threw back his head and roared before dropping an arm around the foreman’s shoulders. “When have you ever known
         me to make a wrong move on an unwilling female?”
      </p>
<p>“Willing or unwilling, Riley Mason is off-limits. And if she doesn’t sue your hide, I’ll do it for her.”</p>
<p><a id="page-20"></a>“Thanks for that fatherly advice. I’ll keep it in mind.”
      </p>
<p>Zane was still chuckling as he joined the others.</p>
<p class="space-break">Riley drove the rental car down the long, curving driveway leading away from the Lost Nugget Ranch.</p>
<p>She was still reeling from her second encounter with the cowboy. She’d had to keep from staring at the change in him. Gone
         was the dark beard, the filthy clothes. He’d been freshly showered and shaved, with little drops of water still glistening
         in his hair. Dark hair, she’d noted, that just brushed the collar of his plaid shirt. Long legs were encased in faded denims.
         On his feet were scuffed boots.
      </p>
<p>He had piercing blue eyes in a tanned face that wasn’t so much handsome as commanding. With that killer smile aimed at her,
         it was impossible to look away. But she wasn’t interested in a fling with a cowboy.
      </p>
<p>A man was the last thing on her mind.</p>
<p>But a job…</p>
<p>The magnitude of what had just transpired came over her in waves.</p>
<p>She had the job.</p>
<p>Right this minute, nothing else mattered except that.</p>
<p>She had the job.</p>
<p>This wasn’t just the start of a new job. This was the start of a brand-new life.</p>
<p>A new life, in a place so far away from where she’d begun, nobody searching for her would ever be able to find her or Summer.</p>
<p>Not ever again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?2a33fa63